<template>
  <div>
    <FileData></FileData>
  </div>
</template>

<script>
import FileData from '../components/FileData.vue';

export default {
  components: {
    FileData,
  },
};
</script>